<template>
  <div class="animated fadeIn">
    <!-- <loader v-if="loading"></loader> -->
    <div>
      <b-row>
        <b-col>
          <component-header
            title="Dashboard"
            :hasSearch="false"
            :hasRadio="true"
            :disableKey="disableKey"
            @dateRangeEmit="dateRangeEmit"
            @radioChangeInputEmit="dateRangeInput"
            :radioOptions="dayRadioOption"
            :hasReload="false"
            :hasClear="false"
            :hasCreate="false"
          />
        </b-col>
      </b-row>
    </div>
    <b-card class="mt-2">
      <b-row>
        <b-col
          sm="6"
          lg="3"
          v-if="
            $userRole == 'Tenant' ||
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/partner' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #ffaf37"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">
                  New/Total Partners
                </h4>
                <h3 class="text-center">
                  {{ dashboard.rangePartnersCount }}/{{
                    dashboard.partnerCount
                  }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col
          sm="6"
          lg="3"
          v-if="$userRole == 'Tenant' && userName != 'kupasatenant'"
        >
          <v-card
            height="100"
            style="border-radius: 10px; border-bottom: 5px solid #737cf4"
          >
            <v-card-text>
              <h4 class="text-muted text-center box-text">
                New/Total Customers
              </h4>
              <h3 class="text-center">
                {{ dashboard.rangeCustomersCount }}/{{
                  dashboard.totalCustomers
                }}
              </h3>
            </v-card-text>
          </v-card>
        </b-col>
        <b-col
          sm="6"
          lg="3"
          v-if="$userRole == 'Tenant' && userName != 'kupasatenant'"
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/setup/service-request' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #ff3a3a"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">
                  Total Service Request
                </h4>
                <h3 class="text-center">
                  {{ dashboard.totalService }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col
          sm="6"
          lg="3"
          v-if="
            ($userRole == 'Tenant' && userName != 'kupasatenant') ||
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <v-card
            height="100"
            style="border-radius: 10px; border-bottom: 5px solid #28a745"
          >
            <v-card-text>
              <h4 class="text-muted text-center box-text">New/Total Items</h4>
              <h3 class="text-center">
                {{ dashboard.rangeItemsCount }}/{{ dashboard.totalItems }}
              </h3>
            </v-card-text>
          </v-card>
        </b-col>
        <b-col
          sm="6"
          lg="3"
          v-if="
            ($userRole == 'Tenant' && userName != 'kupasatenant') ||
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/manage-orders' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #8a76df"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">
                  Total Orders Count
                </h4>
                <h3 class="text-center">
                  {{ dashboard.rangeOrdersCount }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col
          sm="6"
          lg="3"
          v-if="
            ($userRole == 'Tenant' && userName != 'kupasatenant') ||
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/manage-orders' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #ff7250"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">
                  Total Order Amount
                </h4>
                <h3 class="text-center">रु {{ dashboard.rangeAmountCount }}</h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <!-- <b-col
          sm="6"
          lg="3"
          v-if="$userRole == 'Tenant' && userName != 'kupasatenant'"
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/setup/service-request' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #64ffda"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">New Service</h4>
                <h3 class="text-center">
                  {{ dashboard.rangeServiceRequestCount }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col> -->
        <b-col sm="6" lg="3" v-if="$userRole == 'Admin'">
          <v-card
            height="100"
            style="border-radius: 10px; border-bottom: 5px solid #69f0ae"
          >
            <v-card-text>
              <h4 class="text-muted text-center box-text">Total Tenants</h4>
              <h3 class="text-center">{{ adminDashboard.tenantCount }}</h3>
            </v-card-text>
          </v-card>
        </b-col>
        <b-col sm="6" lg="3" v-if="$userRole == 'Admin'">
          <v-card
            height="100"
            style="border-radius: 10px; border-bottom: 5px solid #ffaf37"
          >
            <v-card-text>
              <h4 class="text-muted text-center box-text">Total Partners</h4>
              <h3 class="text-center">
                {{ adminDashboard.partnerCount }}
              </h3>
            </v-card-text>
          </v-card>
        </b-col>
        <b-col sm="6" lg="3" v-if="$userRole == 'Admin'">
          <v-card
            height="100"
            style="border-radius: 10px; border-bottom: 5px solid #6610f2"
          >
            <v-card-text>
              <h4 class="text-muted text-center box-text">Total Customers</h4>
              <h3 class="text-center">{{ adminDashboard.customerCount }}</h3>
            </v-card-text>
          </v-card>
        </b-col>
        <b-col sm="6" lg="3" v-if="$userRole == 'Admin'">
          <v-card
            height="100"
            style="border-radius: 10px; border-bottom: 5px solid #1de9b6"
          >
            <v-card-text>
              <h4 class="text-muted text-center box-text">Total Orders</h4>
              <h3 class="text-center">
                {{ adminDashboard.orderCount }}
              </h3>
            </v-card-text>
          </v-card>
        </b-col>
        <!-- <b-col
          sm="6"
          lg="3"
          v-if="
            $userRole == 'Tenant' ||
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/partner' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #ffaf37"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Total Partners</h4>
                <h3 class="text-center">
                  {{ dashboard.partnerCount }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col> -->
        <!-- <b-col
          sm="6"
          lg="3"
          v-if="$userRole == 'Tenant' && userName != 'kupasatenant'"
        >
          <v-card
            height="100"
            style="border-radius: 10px; border-bottom: 5px solid #85be4c"
          >
            <v-card-text>
              <h4 class="text-muted text-center box-text">Total Customers</h4>
              <h3 class="text-center">
                {{ dashboard.totalCustomers }}
              </h3>
            </v-card-text>
          </v-card>
        </b-col> -->
        <!-- <b-col
          sm="6"
          lg="3"
          v-if="
            ($userRole == 'Tenant' && userName != 'kupasatenant') ||
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/manage-orders' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #37dbff"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Total Orders</h4>
                <h3 class="text-center">
                  {{ dashboard.totalOrders }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col> -->
        <b-col sm="6" lg="3" v-if="this.$currentUserData.category == 'SELLER'">
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/manage-orders' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #37dbff"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Total Orders</h4>
                <h3 class="text-center">
                  {{ dashboard.totalOrders }}
                </h3>
                <strong style="background-color: yellow"
                  >Order Completed : {{ dashboard.totalOrderCompleted }}</strong
                >
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col sm="6" lg="3" v-if="this.$currentUserData.category == 'SELLER'">
          <a
            href="javascript:void(0)"
            @click="
              $router.push({
                path: '/manage-orders',
              })
            "
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #1de9b6"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Live Orders</h4>
                <h3 class="text-center">
                  {{ dashboard.totalLiveOrders }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col sm="6" lg="3" v-if="this.$currentUserData.category == 'SELLER'">
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/manage-orders' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #8bc34a"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Cancelled Order</h4>
                <h3 class="text-center">
                  {{ dashboard.totalCancelledOrders }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col sm="6" lg="3" v-if="this.$currentUserData.category == 'SELLER'">
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/manage-orders' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #4caf50"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Returned Order</h4>
                <h3 class="text-center">
                  {{ dashboard.totalReturnedOrders }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col
          sm="6"
          lg="3"
          v-if="
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <a href="javascript:void(0)" @click="$router.push({ path: '/user' })">
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #a7796f"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Total Agent</h4>
                <h3 class="text-center">
                  {{ dashboard.totalAgent }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col sm="6" lg="3" v-if="this.$currentUserData.category == 'SELLER'">
          <a href="javascript:void(0)" @click="$router.push({ path: '/item' })">
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #ff7337"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Total Items</h4>
                <h3 class="text-center">
                  {{ dashboard.totalItems }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <!-- <b-col
          sm="6"
          lg="3"
          v-if="
            ($userRole == 'Tenant' && userName != 'kupasatenant') ||
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <v-card
            height="100"
            style="border-radius: 10px; border-bottom: 5px solid #ff7337"
          >
            <v-card-text>
              <h4 class="text-muted text-center box-text">Total Items</h4>
              <h3 class="text-center">
                {{ dashboard.totalItems }}
              </h3>
            </v-card-text>
          </v-card>
        </b-col> -->
        <!-- <b-col
          sm="6"
          lg="3"
          v-if="
            ($userRole == 'Tenant' && userName != 'kupasatenant') ||
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/manage-orders' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #28a745"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Order Amount</h4>
                <h3 class="text-center">
                  {{ dashboard.totalAmount }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col> -->
        <b-col sm="6" lg="3" v-if="this.$currentUserData.category == 'SELLER'">
          <v-card
            height="100"
            style="border-radius: 10px; border-bottom: 5px solid #b39ddb"
          >
            <v-card-text>
              <h4 class="text-muted text-center box-text">Item Sold Out</h4>
              <h3 class="text-center">
                {{ dashboard.totalItemSoldOut }}
              </h3>
            </v-card-text>
          </v-card>
        </b-col>
        <b-col sm="6" lg="3" v-if="this.$currentUserData.category == 'SELLER'">
          <v-card
            height="100"
            style="border-radius: 10px; border-bottom: 5px solid #c51162"
          >
            <v-card-text>
              <h4 class="text-muted text-center box-text">Item Low Stock</h4>
              <h3 class="text-center">
                {{ dashboard.totalItemLowStock }}
              </h3>
            </v-card-text>
          </v-card>
        </b-col>
        <b-col
          sm="6"
          lg="3"
          v-if="this.$currentUserData.category == 'DISTRIBUTOR'"
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/payment-history' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #ec4dfa"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Failed Payment</h4>
                <h3 class="text-center">
                  {{ dashboard.totalFailedPayment }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col
          sm="6"
          lg="3"
          v-if="
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/partner' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #17a2b8"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Active Seller</h4>
                <h3 class="text-center">
                  {{ dashboard.totalActiveSeller }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col
          sm="6"
          lg="3"
          v-if="
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <v-card
            height="100"
            style="border-radius: 10px; border-bottom: 5px solid #e83e8c"
          >
            <v-card-text>
              <h4 class="text-muted text-center box-text">New seller</h4>
              <h3 class="text-center">
                {{ dashboard.totalNewSeller }}
              </h3>
            </v-card-text>
          </v-card>
        </b-col>
        <b-col
          sm="6"
          lg="3"
          v-if="
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/partner/view/view-subscription' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #000"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">
                  Upcoming Renewal
                </h4>
                <h3 class="text-center">
                  {{ dashboard.totalUpcomingRenewal }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <!-- <b-col
          sm="6"
          lg="2"
          v-if="
            this.$currentUserData.category == 'DISTRIBUTOR' ||
              this.$currentUserData.category == 'DEALER' ||
              this.$currentUserData.category == 'SELLER'
          "
        >
          <v-card height="120" style="border-radius: 10px; border-bottom: 5px solid #90CAF9 ;">
            <v-card-text class="pb-0">
              <h4 class="text-muted text-center box-text">
                Seller Exceeds Item Limit
              </h4>
              <h2 class=" text-center">
                {{ dashboard.totalSellerExceedsItemLimit }}
              </h2>
            </v-card-text>
          </v-card>
        </b-col> -->
        <b-col
          sm="6"
          lg="3"
          v-if="
            this.$currentUserData.category == 'DISTRIBUTOR' ||
            this.$currentUserData.category == 'DEALER'
          "
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/partner/view/view-subscription' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #6610f2"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">
                  Seller Renewal Due
                </h4>
                <h3 class="text-center">
                  {{ dashboard.totalSellerRenewalDue }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col sm="6" lg="3" v-if="this.$currentUserData.category == 'DEALER'">
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/manage-orders' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #dc3545"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">
                  Total Delivery 1 Week
                </h4>
                <h3 class="text-center">
                  {{ dashboard.totalDelivery }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col
          sm="6"
          lg="3"
          v-if="this.$currentUserData.category == 'DISTRIBUTOR'"
        >
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/approvals' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #ffc107"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">
                  Pending Approval Request
                </h4>
                <h3 class="text-center">
                  {{ dashboard.totalPendingAction }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>

        <b-col sm="6" lg="3" v-if="this.$currentUserData.category == 'SELLER'">
          <v-card
            height="100"
            style="border-radius: 10px; border-bottom: 5px solid #20c997"
          >
            <v-card-text>
              <h4 class="text-muted text-center box-text">Pending Approval</h4>
              <h3 class="text-center">
                {{ dashboard.totalPendingApproval }}
              </h3>
            </v-card-text>
          </v-card>
        </b-col>
        <b-col sm="6" lg="3" v-if="this.$currentUserData.category == 'SELLER'">
          <a href="javascript:void(0)" @click="$router.push({ path: '/item' })">
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #8d6e63"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Online Items</h4>
                <h3 class="text-center">
                  {{ dashboard.totalOnlineItems }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col sm="6" lg="3" v-if="this.$currentUserData.category == 'SELLER'">
          <a href="javascript:void(0)" @click="$router.push({ path: '/item' })">
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #dc3545"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Offline Items</h4>
                <h3 class="text-center">
                  {{ dashboard.totalOfflineItems }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
        <b-col sm="6" lg="3" v-if="this.$currentUserData.category == 'SELLER'">
          <a
            href="javascript:void(0)"
            @click="$router.push({ path: '/myaccount/walletstatement' })"
          >
            <v-card
              height="100"
              style="border-radius: 10px; border-bottom: 5px solid #ffab91"
            >
              <v-card-text>
                <h4 class="text-muted text-center box-text">Due Balance</h4>
                <h3 class="text-center">
                  {{ dashboard.totalDueBalance }}
                </h3>
              </v-card-text>
            </v-card>
          </a>
        </b-col>
      </b-row>
    </b-card>
    <div v-if="$userRole === 'Tenant' && analyticsConfig">
      <b-row class="mx-3">
        <h3>Visits</h3>
      </b-row>
      <b-col id="chart-1-container"></b-col>
      <b-row class="mx-3">
        <b-col>
          <b-row>
            <h3>Top 7 pages</h3>
          </b-row>
          <b-row id="chart-2-container"></b-row>
        </b-col>
        <b-col>
          <b-row>
            <h3>Users devices</h3>
          </b-row>
          <b-row id="chart-3-container"></b-row>
        </b-col>
      </b-row>
      <b-row class="mx-3">
        <h3>Top Users by country</h3>
      </b-row>
      <b-col id="chart-4-container"></b-col>
      <b-row class="mx-3">
        <h3>Users Interest in marketing category</h3>
      </b-row>
      <b-col id="chart-5-container"></b-col>
    </div>
    <b-row>
      <b-col md="7">
        <b-card
          class=""
          v-if="userName != 'kupasatenant'"
          style="border-radius: 16px"
        >
          <div
            v-if="
              this.$currentUserData.category == 'DEALER' ||
              this.$currentUserData.category == 'SELLER'
            "
          >
            <b-tabs pills card lazy>
              <b-tab title="Order Chart" active>
                <lineChart
                  value="order-chart"
                  :labelsData="chartData.labels"
                  :chartData="chartData.datasets"
                />
              </b-tab>
              <b-tab title="Delivery Chart">
                <lineChart
                  value="order-delivered-chart"
                  :labelsData="deliverChart.labels"
                  :chartData="deliverChart.datasets"
                />
              </b-tab>
            </b-tabs>
          </div>
          <div
            v-if="
              this.$currentUserData.category == 'DISTRIBUTOR' ||
              $userRole == 'Tenant' ||
              $userRole == 'Admin'
            "
          >
            <h4>Order Chart</h4>
            <lineChart
              value="orderbyvalue-graph"
              :labelsData="chartData.labels"
              :chartData="chartData.datasets"
            />
          </div>
        </b-card>
      </b-col>
      <b-col md="5">
        <b-card
          class=""
          v-if="userName != 'kupasatenant'"
          style="border-radius: 16px"
        >
          <h4>Total Commission</h4>
          <b-row>
            <b-col md="6"> </b-col>
            <b-col md="6">
              <eb-select
                style="background-color: #fff; width: 75%"
                id="totalcommission"
                type="text"
                label="label"
                v-if="$userRole == 'Tenant'"
                v-model="totalcommissiontenant"
                :options="totalcommissionListtenant"
                placeholder="Select  type"
              ></eb-select>
              <eb-select
                style="background-color: #fff; width: 75%"
                id="totalcommission"
                type="text"
                label="label"
                v-if="this.$currentUserData.category == 'DISTRIBUTOR'"
                v-model="totalcommissiondistributor"
                :options="totalcommissionListdistributor"
                placeholder="Select  type"
              ></eb-select>
              <eb-select
                style="background-color: #fff; width: 75%"
                id="totalcommission"
                type="text"
                label="label"
                v-if="this.$currentUserData.category == 'DEALER'"
                v-model="totalcommissiondealer"
                :options="totalcommissionListdealer"
                placeholder="Select  type"
              ></eb-select>
              <eb-select
                style="background-color: #fff; width: 75%"
                id="totalcommission"
                type="text"
                label="label"
                v-if="this.$currentUserData.category == 'SELLER'"
                v-model="totalcommissionseller"
                :options="totalcommissionListseller"
                placeholder="Select  type"
              ></eb-select>
            </b-col>
          </b-row>
          <div id="app">
            <pie-chart
              class="piechart"
              :data="pieChartData"
              :options="chartOptions"
            ></pie-chart>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ComponentHeader from "@/components/componentHeader";
import LineChart from "@/components/chart/LineChart.vue";
import PieChart from "@/components/chart/piechart.js";
import CardLine1ChartExample from "./dashboard/CardLine1ChartExample";
import CardLine2ChartExample from "./dashboard/CardLine2ChartExample";
import CardLine3ChartExample from "./dashboard/CardLine3ChartExample";
import CardBarChartExample from "./dashboard/CardBarChartExample";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import MainChartExample from "./dashboard/MainChartExample";
import SocialBoxChartExample from "./dashboard/SocialBoxChartExample";
import CalloutChartExample from "./dashboard/CalloutChartExample";
import { Callout } from "@coreui/vue";
import { getAnalyticsConfig } from "@/services/tenant";
import moment from "moment";
export default {
  name: "dashboard",
  components: {
    PieChart,
    ComponentHeader,
    LineChart,
    Callout,
    loader,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    SocialBoxChartExample,
    CalloutChartExample,
    ebSelect,
  },
  data: function () {
    return {
      chartOptions: {
        hoverBorderWidth: 10,
      },
      currentItem: null,
      totalcommissiontenant: "",
      totalcommissiondistributor: "",
      totalcommissiondealer: "",
      totalcommissionseller: "",
      pieChartData: {
        hoverBackgroundColor: "red",
        hoverBorderWidth: 10,
        labels: [
          "Baby Needs",
          "Instant Food",
          "Home Supplies",
          "Beverage",
          "Grocery",
        ],
        datasets: [
          {
            label: "Data One",
            backgroundColor: [
              "#41B883",
              "#E46651",
              "#00D8FF",
              "#ffcc00",
              "#eb6623",
            ],
            data: [7, 10, 5, 9, 10],
          },
        ],
      },
      adminDashboard: {
        tenantCount: 0,
        partnerCount: 0,
        customerCount: 0,
        orderCount: 0,
      },
      dashboard: {
        partnerCount: 0,
        totalItems: 0,
        totalCustomers: 0,
        totalOrders: 0,
        totalAmount: 0,
        totalService: 0,
        totalAgent: 0,
        totalActiveSeller: 0,
        totalNewSeller: 0,
        totalUpcomingRenewal: 0,
        totalSellerRenewalDue: 0,
        totalSellerExceedsItemLimit: 0,
        totalDueBalance: 0,
        totalDelivery: 0,
        totalPendingAction: 0,
        totalFailedPayment: 0,
        totalOrderCompleted: 0,
        totalLiveOrders: 0,
        totalCancelledOrders: 0,
        totalReturnedOrders: 0,
        totalItemSoldOut: 0,
        totalPendingApproval: 0,
        totalOfflineItems: 0,
        totalOnlineItems: 0,
        totalItemLowStock: 0,
        rangePartnersCount: 0,
        rangeCustomersCount: 0,
        rangeOrdersCount: 0,
        rangeItemsCount: 0,
        rangeAmountCount: 0,
        rangeServiceRequestCount: 0,
      },
      saleschartdata: [],
      totalsales: 0,
      totalCost: 0,
      loading: false,
      salesCount: null,
      userName: null,
      adsCount: null,
      selected: "Month",
      tableItems: [
        {
          avatar: { url: "img/avatars/1.jpg", status: "success" },
          user: {
            name: "Yiorgos Avraamu",
            new: true,
            registered: "Jan 1, 2015",
          },
          country: { name: "USA", flag: "us" },
          usage: { value: 50, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Mastercard", icon: "fa fa-cc-mastercard" },
          activity: "10 sec ago",
        },
        {
          avatar: { url: "img/avatars/2.jpg", status: "danger" },
          user: {
            name: "Avram Tarasios",
            new: false,
            registered: "Jan 1, 2015",
          },
          country: { name: "Brazil", flag: "br" },
          usage: { value: 22, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Visa", icon: "fa fa-cc-visa" },
          activity: "5 minutes ago",
        },
        {
          avatar: { url: "img/avatars/3.jpg", status: "warning" },
          user: { name: "Quintin Ed", new: true, registered: "Jan 1, 2015" },
          country: { name: "India", flag: "in" },
          usage: { value: 74, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Stripe", icon: "fa fa-cc-stripe" },
          activity: "1 hour ago",
        },
        {
          avatar: { url: "img/avatars/4.jpg", status: "" },
          user: { name: "Enéas Kwadwo", new: true, registered: "Jan 1, 2015" },
          country: { name: "France", flag: "fr" },
          usage: { value: 98, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "PayPal", icon: "fa fa-paypal" },
          activity: "Last month",
        },
        {
          avatar: { url: "img/avatars/5.jpg", status: "success" },
          user: {
            name: "Agapetus Tadeáš",
            new: true,
            registered: "Jan 1, 2015",
          },
          country: { name: "Spain", flag: "es" },
          usage: { value: 22, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Google Wallet", icon: "fa fa-google-wallet" },
          activity: "Last week",
        },
        {
          avatar: { url: "img/avatars/6.jpg", status: "danger" },
          user: {
            name: "Friderik Dávid",
            new: true,
            registered: "Jan 1, 2015",
          },
          country: { name: "Poland", flag: "pl" },
          usage: { value: 43, period: "Jun 11, 2015 - Jul 10, 2015" },
          payment: { name: "Amex", icon: "fa fa-cc-amex" },
          activity: "Last week",
        },
      ],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: "text-center",
        },
        user: {
          label: "User",
        },
        country: {
          label: "Country",
          class: "text-center",
        },
        usage: {
          label: "Usage",
        },
        payment: {
          label: "Payment method",
        },
        activity: {
          label: "Activity",
        },
      },
      analyticsConfig: null,
      totalcommissionListtenant: [
        {
          label: "State Operating Unit",
          value: "DISTRIBUTOR",
        },
        {
          label: "Sector Franchisee",
          value: "DEALER",
        },
      ],
      totalcommissionListdistributor: [
        {
          label: "Market",
          value: "MARKET",
        },
        {
          label: "City",
          value: "CITY",
        },
      ],
      dayRadioOption: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 days",
          value: 7,
        },
        {
          text: "30 days",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      totalcommissionListdealer: [
        {
          label: "Sales",
          value: "SALES",
        },
      ],
      totalcommissionListseller: [
        {
          label: "Product Type",
          value: "PRODUCT_TYPE",
        },
        {
          label: "Category",
          value: "CATEGORY",
        },
      ],
      items: ["Order ", "Delivery"],
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      disableKey: false,
      dateFilter: 1,
    };
  },
  computed: {
    userId() {
      if (this.$store.getters["auth/getUserID"]) {
        return this.$store.getters["auth/getUserID"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
      }
    },
    chartData() {
      let dataList = this.$store.getters["partner/getBulkAnalyticsReport"];
      const labels = [];
      const datasets = [
        {
          label: "Order Amount",
          fill: false,
          borderColor: "#2554FF",
          backgroundColor: "#2554FF",
          pointBorderColor: "#2554FF",
          borderWidth: 3,
          data: [],
        },
        {
          label: "Order Count",
          fill: false,
          borderColor: "#FF54FF",
          backgroundColor: "#FF54FF",
          pointBorderColor: "#FF54FF",
          borderWidth: 3,
          data: [],
        },
      ];
      if (dataList && dataList["orderbyvalue-graph"]) {
        if (dataList["orderbyvalue-graph"].length > 0) {
          dataList["orderbyvalue-graph"].map((x) => {
            labels.push(`${x.month}-${x.year}`);
            datasets[0].data.push(+parseFloat(x.totalamount).toFixed(2));
            datasets[1].data.push(+parseFloat(x.totalorders).toFixed(2));
          });
        }
      }
      return {
        labels,
        datasets,
      };
    },
    deliverChart() {
      let dataList = this.$store.getters["partner/getBulkAnalyticsReport"];
      const labels = [];
      const datasets = [
        {
          label: "Order Delivery Amount",
          fill: false,
          borderColor: "#2554FF",
          backgroundColor: "#2554FF",
          pointBorderColor: "#2554FF",
          borderWidth: 3,
          data: [],
        },
        {
          label: "Order Delivery Count",
          fill: false,
          borderColor: "#FF54FF",
          backgroundColor: "#FF54FF",
          pointBorderColor: "#FF54FF",
          borderWidth: 3,
          data: [],
        },
      ];
      if (dataList && dataList["order-delivered-chart"]) {
        if (dataList["order-delivered-chart"].length > 0) {
          dataList["order-delivered-chart"].map((x) => {
            labels.push(`${x.month}-${x.year}`);
            datasets[0].data.push(+parseFloat(x.totalamount).toFixed(2));
            datasets[1].data.push(+parseFloat(x.totalorders).toFixed(2));
          });
        }
      }
      return {
        labels,
        datasets,
      };
    },
  },
  methods: {
    dateRangeEmit(e) {
      let emitData = {
        fromDate: e.startDate,
        toDate: e.endDate,
      };
      this.dateFilter = emitData;
      this.getAnalyticsDataAll();
    },
    dateRangeInput(e) {
      this.dateFilter = e;
      this.getAnalyticsDataAll();
    },
    addItem(item) {
      const removed = this.items.splice(0, 1);
      this.items.push(...this.more.splice(this.more.indexOf(item), 1));
      this.more.push(...removed);
      this.$nextTick(() => {
        this.currentItem = "tab-" + item;
      });
    },
    variant(value) {
      let $variant;
      if (value <= 25) {
        $variant = "info";
      } else if (value > 25 && value <= 50) {
        $variant = "success";
      } else if (value > 50 && value <= 75) {
        $variant = "warning";
      } else if (value > 75 && value <= 100) {
        $variant = "danger";
      }
      return $variant;
    },
    flag(value) {
      return "flag-icon flag-icon-" + value;
    },
    getDateData() {
      const data = {
        startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      };
      if (typeof this.dateFilter === "number") {
        data.startDate = moment()
          .subtract(this.dateFilter, "days")
          .format("YYYY-MM-DD");
        return data;
      } else if (typeof this.dateFilter === "object") {
        return this.dateFilter;
      }
      return data;
    },

    getAllDateRange() {
      const data = {
        fromDate: "1900-01-01",
        toDate: moment().format("YYYY-MM-DD"),
      };
      return data;
    },

    getDateRange() {
      const data = {
        fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
        toDate: moment().format("YYYY-MM-DD"),
      };
      if (typeof this.dateFilter === "number") {
        data.fromDate = moment()
          .subtract(this.dateFilter - 1, "days")
          .format("YYYY-MM-DD");
        return data;
      } else if (typeof this.dateFilter === "object") {
        return this.dateFilter;
      }
      return data;
    },

    async getAnalyticsData() {
      const dataList = [
        {
          key: "active-seller",
          variables: {
            userId: this.userId,
            status: "ACTIVE",
            category: "SELLER",
          },
        },
        {
          key: "upcoming-renewal",
          variables: {
            userId: this.userId,
            status: "ACTIVE",
            ...this.getDateData(),
          },
        },
        {
          key: "total-order-month",
          variables: {
            userId: this.userId,
            ...this.getDateData(),
          },
        },
        {
          key: "new-seller",
          variables: {
            userId: this.userId,
            status: "ACTIVE",
            category: "SELLER",
            ...this.getDateData(),
          },
        },
        {
          key: "total-agent",
          variables: {
            userId: this.userId,
          },
        },
        {
          key: "total-partner",
          variables: {
            userId: this.userId,
          },
        },
        {
          key: "total-item",
          variables: {
            userId: this.userId,
            status: "ACTIVE",
            category: "SELLER",
            itemStatus: "false",
          },
        },
        {
          key: "seller-renewal",
          variables: {
            userId: this.userId,
            status: "ACTIVE",
            category: "SELLER",
            ...this.getDateData(),
          },
        },
      ];
      if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER"
      ) {
        const data = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          {
            items: dataList,
          }
        );
        this.loading = false;
        this.dashboard.partnerCount = data["total-partner"].totalpartner;
        this.dashboard.totalOrders = data["total-order-month"].totalorder;
        this.dashboard.totalAgent = data["total-agent"].totalagent;
        this.dashboard.totalItems = data["total-item"].totalitems;
        this.dashboard.totalAmount = data["total-order-month"].orderamt || 0;
        this.dashboard.totalActiveSeller =
          data["active-seller"].totalactiveseller;
        this.dashboard.totalNewSeller = data["new-seller"].totalnewseller;
        this.dashboard.totalUpcomingRenewal =
          data["upcoming-renewal"].totalrenewal;
        this.dashboard.totalSellerRenewalDue =
          data["seller-renewal"].totalrenewalseller;
      }
      const dataList1 = [
        {
          key: "failed-order",
          variables: {
            userId: this.userId,
            orderStatus: "Failed",
          },
        },
        {
          key: "approval-request",
          variables: {
            userId: this.userId,
            status: "PENDING",
          },
        },
      ];
      if (this.$currentUserData.category === "DISTRIBUTOR") {
        const data = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          {
            items: dataList1,
          }
        );
        this.loading = false;
        this.dashboard.totalPendingAction =
          data["approval-request"].totalrequest;
        this.dashboard.totalFailedPayment = data["failed-order"].totalorder;
      }
      const dataList2 = [
        {
          key: "total-delivery-week",
          variables: {
            userId: this.userId,
            status: "Delivered",
            ...this.getDateData(),
          },
        },
      ];
      if (this.$currentUserData.category === "DEALER") {
        const data = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          {
            items: dataList2,
          }
        );
        this.loading = false;
        this.dashboard.totalDelivery =
          data["total-delivery-week"].deliverycount;
      }
      const dataList3 = [
        {
          key: "total-order-month",
          variables: {
            userId: this.userId,
            ...this.getDateData(),
          },
        },
        {
          key: "cancell-order",
          variables: {
            userId: this.userId,
            orderStatus: "Cancelled",
          },
        },
        {
          key: "total-item",
          variables: {
            userId: this.userId,
            status: "ACTIVE",
            category: "SELLER",
            itemStatus: "false",
          },
        },
        {
          key: "pending-approval",
          variables: {
            userId: this.userId,
            status: "PENDING",
          },
        },
        {
          key: "offline-items",
          variables: {
            userId: this.userId,
            status: "true",
          },
        },
        {
          key: "online-items",
          variables: {
            userId: this.userId,
            status: "false",
          },
        },
        {
          key: "sold-out-items",
          variables: {
            userId: this.userId,
            status: "ACTIVE",
            category: "SELLER",
            itemStatus: "false",
            itemAvailability: "OUT OF STOCK",
          },
        },
        {
          key: "live-order",
          variables: {
            userId: this.userId,
            orderStatus: "Created",
          },
        },
        {
          key: "returned-order",
          variables: {
            userId: this.userId,
            orderStatus: "Returned",
          },
        },
        {
          key: "completed-order",
          variables: {
            userId: this.userId,
            orderStatus: "Completed",
          },
        },
        {
          key: "low-stock-items",
          variables: {
            userId: this.userId,
            status: "ACTIVE",
            category: "SELLER",
            itemStatus: "false",
            itemAvailability: "LOW STOCK",
          },
        },
        {
          key: "wallet-balance",
          variables: {
            userId: this.userId,
          },
        },
      ];
      if (this.$currentUserData.category === "SELLER") {
        const data = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          {
            items: dataList3,
          }
        );
        this.loading = false;
        this.dashboard.totalOrders = data["total-order-month"].totalorder;
        this.dashboard.totalCancelledOrders = data["cancell-order"].totalorder;
        this.dashboard.totalItems = data["total-item"].totalitems;
        this.dashboard.totalPendingApproval =
          data["pending-approval"].totalpendingapproval;
        this.dashboard.totalOfflineItems = data["offline-items"].totalitem;
        this.dashboard.totalOnlineItems = data["online-items"].totalitem;
        this.dashboard.totalItemSoldOut = data["sold-out-items"].totalitems;
        this.dashboard.totalReturnedOrders = data["returned-order"].totalorder;
        this.dashboard.totalLiveOrders = data["live-order"].totalorder;
        this.dashboard.totalOrderCompleted = data["completed-order"].totalorder;
        this.dashboard.totalItemLowStock = data["low-stock-items"].totalitems;
        this.dashboard.totalDueBalance = data["wallet-balance"].totalbalance;
      }
    },
    async getTenantAnalyticsData() {
      const dataList = [
        {
          key: "total-merchant",
          variables: {
            tenant: this.userId,
            ...this.getDateRange(),
          },
        },
        {
          key: "total-customers",
          variables: {
            tenant: this.userId,
            ...this.getDateRange(),
          },
        },
        {
          key: "total-orders",
          variables: {
            tenant: this.userId,
            ...this.getDateRange(),
          },
        },
        {
          key: "total-items",
          variables: {
            tenant: this.userId,
            ...this.getDateRange(),
          },
        },
        {
          key: "total-servicerequests",
          variables: {
            tenant: this.userId,
            ...this.getDateRange(),
          },
        },
      ];

      const data = await this.$store
        .dispatch("partner/fetchBulkAnalyticReport", { items: dataList })
        .then((data) => {
          this.dashboard.rangePartnersCount = data["total-merchant"].count || 0;
          this.dashboard.rangeCustomersCount =
            data["total-customers"].total_customer || 0;
          this.dashboard.rangeOrdersCount =
            data["total-orders"].total_order || 0;
          this.dashboard.rangeItemsCount = data["total-items"].items || 0;
          this.dashboard.rangeAmountCount = (
            +data["total-orders"]?.total_order_amount || 0
          ).toFixed(2);
          this.dashboard.rangeServiceRequestCount =
            data["total-servicerequests"].servicerequest || 0;
        });
      const allDataList = [
        {
          key: "total-merchant",
          variables: {
            tenant: this.userId,
            ...this.getAllDateRange(),
          },
        },
        {
          key: "total-customers",
          variables: {
            tenant: this.userId,
            ...this.getAllDateRange(),
          },
        },
        {
          key: "total-orders",
          variables: {
            tenant: this.userId,
            ...this.getAllDateRange(),
          },
        },
        {
          key: "total-items",
          variables: {
            tenant: this.userId,
            ...this.getAllDateRange(),
          },
        },
        {
          key: "total-servicerequests",
          variables: {
            tenant: this.userId,
            ...this.getAllDateRange(),
          },
        },
      ];

      const AllData = await this.$store
        .dispatch("partner/fetchBulkAnalyticReport", { items: allDataList })
        .then((data) => {
          this.dashboard.partnerCount = data["total-merchant"].count || 0;
          this.dashboard.totalItems = data["total-items"].items || 0;
          this.dashboard.totalCustomers =
            data["total-customers"].total_customer || 0;
          this.dashboard.totalOrders = data["total-orders"].total_order || 0;
          this.dashboard.totalAmount = (
            +data["total-orders"]?.total_order_amount || 0
          ).toFixed(2);
          this.dashboard.totalService =
            data["total-servicerequests"].servicerequest || 0;
        });
    },
    async getAdminAnalyticsData() {
      const dataList = [
        {
          key: "admin-tenants",
          variables: {
            userId: this.userId,
          },
        },
        {
          key: "admin-partner",
          variables: {
            userId: this.userId,
          },
        },
        {
          key: "admin-customers",
          variables: {
            userId: this.userId,
          },
        },
        {
          key: "admin-orders",
          variables: {
            userId: this.userId,
          },
        },
      ];
      const data = await this.$store
        .dispatch("partner/fetchBulkAnalyticReport", { items: dataList })
        .then((data) => {
          this.loading = false;
          this.adminDashboard.tenantCount = data["admin-tenants"].totaltenant;
          this.adminDashboard.partnerCount = data["admin-partner"].totalpartner;
          this.adminDashboard.customerCount =
            data["admin-customers"].totalcustomer;
          this.adminDashboard.orderCount = data["admin-orders"].totatorder;
        });
    },
    getAnalyticsDataAll() {
      if (this.$userRole === "Tenant" && this.userId) {
        this.getTenantAnalyticsData();
      } else if (this.$userRole === "Partner" && this.userId) {
        this.getAnalyticsData();
      } else if (this.$userRole === "Admin" && this.userId) {
        this.getAdminAnalyticsData();
      }
    },
  },
  async mounted() {
    this.loading = false;
    this.getAnalyticsDataAll();
    const dataList = [
      {
        key: "orderbyvalue-graph",
        variables: {
          tenant: this.userId,
          ...this.getDateRange(),
        },
      },
    ];
    if (
      this.$userRole === "Tenant" ||
      this.$currentUserData.category == "DISTRIBUTOR" ||
      this.$currentUserData.category == "DEALER" ||
      this.$currentUserData.category == "SELLER"
    ) {
      const data = await this.$store.dispatch("partner/fetchBulkChart", {
        items: dataList,
      });
    }
    const dataList1 = [
      {
        key: "order-delivered-chart",
        variables: {
          userId: this.userId,
        },
      },
    ];
    if (
      this.$currentUserData.category == "DEALER" ||
      this.$currentUserData.category == "SELLER"
    ) {
      const data = await this.$store.dispatch("partner/fetchBulkChart", {
        items: dataList1,
      });
    }
    // if (this.$userRole === "Admin") {
    //   this.$store.dispatch("tenant/fetchTenantsList").then((data) => {
    //     this.tenantCount = data.response.length;
    //   });
    // this.$store.dispatch("partner/fetchPartnersList").then((data) => {
    //   this.partnercount = data.response.length;
    // });
    //   this.loading = false;
    // } else if (this.$userRole === "Partner" && this.userId) {
    //   this.$store
    //     .dispatch("order/fetchPartner30daysorderscount")
    //     .then((res) => {
    //       if (res.status === 1) {
    //         const data = res.response;
    //         if (data && data.length > 0) {
    //           data.map((obj) => {
    //             this.saleschartdata.push(obj.count);
    //           });
    //         }
    //         console.log(this.saleschartdata);
    //       }
    //     });
    //   //  this.$store.dispatch("order/fetchOrderForSeller", 30).then(data => {
    //   //     console.log(data);
    //   //     this.ordersCount = data.response.length;
    //   //   });
    //   this.$store
    //     .dispatch("order/fetchPartnerSalesGroup", this.userId)
    //     .then((res) => {
    //       if (res.status === 1) {
    //         const data = res.response;
    //         this.salesCount = data.length;
    //         if (data && data.length > 0) {
    //           const salesnumbers = [];
    //           data.map((obj) => {
    //             if (obj) {
    //               salesnumbers.push(obj.saleValue);
    //             }
    //           });
    //           this.totalsales = salesnumbers.reduce((a, b) => a + b, 0);
    //         }
    //       }
    //     });
    //   this.$store.dispatch("order/fetchPartnerSalesGroup").then((res) => {
    //     if (res.status === 1) {
    //       const data = res.response;
    //       if (data && data.length > 0) {
    //         const salesnumbers = [];
    //         data.map((obj) => {
    //           if (obj) {
    //             salesnumbers.push(obj.saleValue);
    //           }
    //         });
    //         this.totalsales = salesnumbers.reduce((a, b) => a + b, 0);
    //       }
    //     }
    //   });
    //   this.loading = false;
    // } else if (this.$userRole === "Tenant" && this.userId) {
    // this.userName = sessionStorage.getItem("userName");
    //   if (this.userName == "kupasatenant") {
    //     this.$store.dispatch("tenant/fetchAdsCount").then(data => {
    //       this.adsCount = data.count;
    //     });
    //   }
    //   this.$store.dispatch("item/fetchTenantsItemCount").then(data => {
    //     this.totalItems = data.status === 1 ? data.count : 0;
    //   });
    //   this.$store.dispatch("partner/fetchPartnersList").then(data => {
    //     this.partnerCount = data.response.length;
    //   });
    //   this.$store
    //     .dispatch("order/fetchOrderForTenant", { id: this.userId, count: 7 })
    //     .then(data => {
    //       console.log(data);
    //       this.ordersCount = data.response.length;
    //     });
    //   this.$store
    //     .dispatch("order/fetchTenant30daysorderscount", this.userId)
    //     .then(res => {
    //       if (res.status === 1) {
    //         const data = res.response;
    //         if (data && data.length > 0) {
    //           data.map(obj => {
    //             this.saleschartdata.push(obj.count);
    //           });
    //         }
    //         console.log(this.saleschartdata);
    //       }
    //     });
    //   this.$store
    //     .dispatch("order/fetchTenantSalesGroup", this.userId)
    //     .then(res => {
    //       if (res.status === 1) {
    //         const data = res.response;
    //         this.salesCount = data.length;
    //         if (data && data.length > 0) {
    //           const salesnumbers = [];
    //           data.map(obj => {
    //             if (obj) {
    //               salesnumbers.push(obj.saleValue);
    //             }
    //           });
    //           this.totalsales = salesnumbers.reduce((a, b) => a + b, 0);
    //         }
    //       }
    //     });
    //   this.$store.dispatch("order/fetchTotalDeliveryCost").then(res => {
    //     if (res.status === 1) {
    //       const data = res.response[0];
    //       this.totalCost = data.totalCost;
    //     }
    //   //   });
    //   this.loading = false;
    // }
    try {
      const data = await getAnalyticsConfig();
      this.analyticsConfig = data.response;
      window.gapi.analytics.ready(() => {
        window.gapi.analytics.auth.authorize({
          serverAuth: {
            access_token: this.analyticsConfig.token,
          },
        });
        // NOTE: Add `<b-row id="view-selector-container"></b-row>` anywhere in ui
        // and enable function below in case at some point we have any tenant who
        // has multiple website configure to their analytics account
        // new window.gapi.analytics.ViewSelector({
        //   container: 'view-selector-container'
        // }).execute();
        new window.gapi.analytics.googleCharts.DataChart({
          query: {
            ids: `ga:${this.analyticsConfig.viewId}`,
            "start-date": "30daysAgo",
            "end-date": "today",
            metrics: "ga:sessions,ga:users,ga:bounces",
            dimensions: "ga:date",
          },
          chart: {
            container: "chart-1-container",
            type: "LINE",
            options: {
              width: "100%",
            },
          },
        }).execute();
        new window.gapi.analytics.googleCharts.DataChart({
          query: {
            ids: `ga:${this.analyticsConfig.viewId}`,
            "start-date": "30daysAgo",
            "end-date": "today",
            metrics: "ga:pageviews",
            dimensions: "ga:pagePathLevel1",
            sort: "-ga:pageviews",
            filters: "ga:pagePathLevel1!=/",
            "max-results": 7,
          },
          chart: {
            container: "chart-2-container",
            type: "PIE",
            options: {
              pieHole: 4 / 9,
            },
          },
        }).execute();
        new window.gapi.analytics.googleCharts.DataChart({
          query: {
            ids: `ga:${this.analyticsConfig.viewId}`,
            "start-date": "30daysAgo",
            "end-date": "today",
            metrics: "ga:sessions",
            dimensions: "ga:browser",
            "max-results": 7,
          },
          chart: {
            container: "chart-3-container",
            type: "PIE",
            options: {
              pieHole: 4 / 9,
            },
          },
        }).execute();
        new window.gapi.analytics.googleCharts.DataChart({
          query: {
            ids: `ga:${this.analyticsConfig.viewId}`,
            "start-date": "30daysAgo",
            "end-date": "today",
            metrics: "ga:users,ga:newUsers",
            dimensions: "ga:country",
            sort: "-ga:users",
            "max-results": 10,
          },
          chart: {
            container: "chart-4-container",
            type: "BAR",
            options: {
              width: "100%",
              label: "Chart 4",
              borderWidth: 1000,
            },
          },
        }).execute();
        new window.gapi.analytics.googleCharts.DataChart({
          query: {
            ids: `ga:${this.analyticsConfig.viewId}`,
            "start-date": "30daysAgo",
            "end-date": "today",
            metrics: "ga:users,ga:newUsers",
            dimensions: "ga:interestInMarketCategory",
            sort: "-ga:users",
            "max-results": 10,
          },
          chart: {
            container: "chart-5-container",
            type: "LINE",
            options: {
              width: "100%",
            },
          },
        }).execute();
      });
    } catch (e) {}
  },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.piechart {
  display: block;
  height: 300px;
  width: 300px;
}
.v-tabs__slider {
  height: 43px;
  width: 100%;
  border-radius: 18px;
  left: 20px;
  margin-top: -8px;
  margin-bottom: 2px;
}
.v-tabs__container {
  background: #727cf5;
  border-radius: 18px;
}
.v-tabs__slider-wrapper {
  bottom: 0;
  margin: 0 !important;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  left: 45px;
  width: 200px;
}
v-tabs__slider-wrapper {
  left: 1px;
  width: 160px;
}
.box-text {
  font-size: 13px;
}
.v-card.v-sheet.theme--light {
  margin-bottom: 20px;
}
</style>
